module.exports = __webpack_public_path__ + "static/img/expired-trial.da6af054.svg";